import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../modules/react/hooks/useQuery';
import LocalesDropdown from '../components/LocalesDropdown';
import NavigationLocalesMenuItem from '../components/NavigationLocalesMenuItem';

const GET_DATA = gql`
  query GetNavigationLocalesDropdownData{
    currentCompany {
      id
      locales {
        ...LocalesDropdownLocale
        ...NavigationLocalesMenuItemLocale
      }
    }
  }

  ${LocalesDropdown.fragments.locale}
  ${NavigationLocalesMenuItem.fragments.locale}
`;

const propTypes = {
  code: PropTypes.string.isRequired,
};

const defaultProps = {};

const NavigationLocalesDropdown = ({
  code,
  ...rest
}) => {
  const { data } = useQuery(GET_DATA, { variables: { ssr: false } });

  if (!data) {
    return null;
  }

  const { currentCompany: { locales } } = data;

  const locale = locales.find(potentialLocale => potentialLocale.code === code);

  return (
    <LocalesDropdown
      {...rest}
      componentClass={NavigationLocalesMenuItem}
      locale={locale}
      locales={locales}
    />
  );
};

NavigationLocalesDropdown.propTypes = propTypes;
NavigationLocalesDropdown.defaultProps = defaultProps;

export default NavigationLocalesDropdown;
